// const serverUrl = "https://mern-ecommerce-v1zb.onrender.com"
// const serverUrl = "https://137.184.162.5"
const serverUrl = "https://merncommerce.duckdns.org"

export default serverUrl